module.exports = __webpack_public_path__ + "img/lead-amount.dbf5ae59.svg";